import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenStatus } from "@/enum";

const { REQUIRED } = ERROR_TYPE;

/**
 * Response of `GET /token/validate` — used to check an invitation/reset token's status up front
 * (on the SetPassword page load) before the user types a password. `email` is only returned for
 * EXPIRED tokens, so the UI can offer a "resend" path.
 */
export const ValidateTokenResponseSchema = z.object({
	status: z.nativeEnum(TokenStatus),
	email: z.string().email().optional(),
});

export const ResendTokenRequestSchema = z.object({
	token: z.string().min(1, { message: REQUIRED }),
});

/** `POST /token/resend` returns the shared `BaseResponseDTO<null>` (`{ status: "ok" }`). */
export const ResendTokenResponseSchema = z.object({
	status: z.string(),
});

export type ValidateTokenResponse = z.infer<typeof ValidateTokenResponseSchema>;
export type ResendTokenBody = z.infer<typeof ResendTokenRequestSchema>;
export type ResendTokenResponse = z.infer<typeof ResendTokenResponseSchema>;
